import React from "react";
export default function CoinTabs({ coins, active, onChange, prices }) {
  return (
    <div style={{ display:"flex",gap:6,padding:"10px 20px",background:"#0a0c10",
      borderBottom:"1px solid #1e2433",overflowX:"auto" }}>
      {Object.entries(coins).map(([sym, info]) => {
        const isActive = sym === active;
        const p = prices?.[sym];
        const up = p && p.change_24h >= 0;
        return (
          <button key={sym} onClick={() => onChange(sym)} style={{
            display:"flex",alignItems:"center",gap:8,padding:"7px 16px",
            borderRadius:8,cursor:"pointer",fontSize:13,fontWeight:isActive?700:500,
            background:isActive?`${info.color}18`:"#111318",
            border:isActive?`1.5px solid ${info.color}`:"1px solid #1e2433",
            color:isActive?info.color:"#6b7280",whiteSpace:"nowrap",
          }}>
            <span style={{ width:8,height:8,borderRadius:"50%",background:info.color,
              opacity:isActive?1:0.4,flexShrink:0 }}/>
            {sym}
            {p && <span style={{ fontSize:12,color:up?"#22c55e":"#ef4444",fontWeight:600 }}>
              {up?"▲":"▼"}{Math.abs(p.change_24h).toFixed(1)}%
            </span>}
          </button>
        );
      })}
    </div>
  );
}
